module.exports = __webpack_public_path__ + "img/high_risk_areas_bu.7466eb98.png";